var AbstractView = require("./AbstractView");

/**
 * Base class for all views that provide the ability to edit the subject of the view
 *
 * @class
 * @extends AbstractView
 */
function AbstractEditView() {
    /**
     * Adds the necessary CSS class to the header to override the back button styling so that it appears as a close button
     * @override
     * @return {DefaultHeader~Configuration}
     */
    this.getHeaderConfiguration = function() {
        return {
            title : "",
            additionalClasses : "close"};
    };

    this.resize = function(width, height) {
        this.getContent().height(height);
        this.getContent().width(width);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };
}

AbstractEditView.prototype = AbstractView;

module.exports = AbstractEditView;


//////////////////
// WEBPACK FOOTER
// ./common/AbstractEditView.js
// module id = 51
// module chunks = 0